export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";